import { render } from "./newsCenter.vue?vue&type=template&id=dc9c030c"
import script from "./newsCenter.vue?vue&type=script&lang=js"
export * from "./newsCenter.vue?vue&type=script&lang=js"

import "./newsCenter.vue?vue&type=style&index=0&id=dc9c030c&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__